import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { EndpointResponse } from '@/types/endpoints';
import type { CustomPrice, PriceWrite } from '@/types/pricing';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

/** kitchensink requires the subscription and a price above zero. A blank MSRP or MAPP is left out. */
export type CustomPriceCreate = { subscription_id: number; price: PriceWrite; msrp?: PriceWrite; mapp?: PriceWrite };

/** Adds a subscription's price. A subscription has at most one, so a second create for it fails. */
export const createCustomPrice = async (
  scope: RequestScope,
  { itemId, data }: { itemId: number; data: CustomPriceCreate },
  options: WriteRequestOptions
): Promise<EndpointResponse<CustomPrice>> => {
  try {
    const response = await scopedApi(scope).post<EndpointResponse<CustomPrice>>(`pricing_item/${itemId}/custom_pricing`, data, options);
    return response.data;
  } catch (error) {
    return utils.error.handleAxiosError(error, { redactRequestData: true });
  }
};
